import { DOC_PATH, FOLDER_ROUTE_PATH, HANDBOOK_PATH, WORKSPACE_PATH } from 'paths'
import { matchPath } from 'react-router-dom'

export function metaFromPath(path: string): { articleKey?: string; workspaceId?: number; handbookKey?: string } | null {
  const workspaceMatch = matchPath<{ workspaceId: string }>(path, { path: WORKSPACE_PATH, strict: false })
  const workspaceId = Number(workspaceMatch?.params.workspaceId)
  if (!isNaN(workspaceId)) {
    return { workspaceId }
  }

  const handbookMatch = matchPath<{ folderSlug: string; doc: string }>(path, {
    path: [FOLDER_ROUTE_PATH, HANDBOOK_PATH],
  })
  if (handbookMatch != null && /\w{6}$/.test(handbookMatch.params.folderSlug)) {
    // As per `app/models/handbook.rb::generate_key` is `SecureRandom.alphanumeric(6)`
    const handbookKey = handbookMatch.params.folderSlug.slice(-6)
    return { handbookKey }
  }

  const docMatch = matchPath<{ slug: string }>(path, { path: DOC_PATH, strict: false })
  if (docMatch?.params.slug && /\w{32}$/.test(docMatch.params.slug)) {
    // As per `app/models/article.rb::generate_key` is `SecureRandom.alphanumeric(32)`
    const articleKey = docMatch.params.slug.slice(-32)
    return { articleKey }
  }

  return null
}
